__turbopack_context__.v({
  "errorImage": "page-module___8aEwW__errorImage",
  "header": "page-module___8aEwW__header",
  "loading": "page-module___8aEwW__loading",
  "loadingMore": "page-module___8aEwW__loadingMore",
  "main": "page-module___8aEwW__main",
});
